import {
  MQState,
  MQ_IN_PROGRESS,
  MQInProgressAction,
  MQInProgress,
  MQ_CATEGORY,
  MQCategoryAction,
  MQCategory,
  MQ_STARTED,
  MQ_MESSAGE_SHOW,
  MQ_ELIGIBLE,
  ELIGIBILITY_CANNOT_BE_DETERMINED,
  MQ_SET_DECLARATION,
  MQ_SUBMIT,
  MQSubmitAction,
  MQSubmit,
  RESET_PAX_MQ,
  MQ_RESET_CATEGORY,
  RESET_MQ,
  MQResetPaxAction,
  MQ_COMPLETED,
  MQActions
} from './types';
import { filter, flatMap, get, omit } from 'lodash';
import { RESET_PAX, RESET_STORE, STORE, WhitelistAction } from '../global';
import { checkWhitelist } from '../reducer-utils';

const initialState = { inProgressMQ: {} };

const validateEligibility = (
  state: MQState = { inProgressMQ: {} },
  action: MQInProgressAction | MQCategoryAction
): MQState => {
  switch (action.type) {
    case MQ_ELIGIBLE: {
      const { paxId, isEligible } = action.payload as { paxId: number; isEligible: boolean };
      return {
        ...state,
        mqPaxIdEligible: {
          ...state.mqPaxIdEligible,
          [paxId]: { mqEligible: isEligible }
        }
      };
    }
    case ELIGIBILITY_CANNOT_BE_DETERMINED: {
      return {
        ...state,
        inProgressMQ: {
          ...state.inProgressMQ,
          // @ts-ignore
          eligibilityCannotBeDeterminedShow: action.payload as boolean
        }
      };
    }
    case MQ_SET_DECLARATION: {
      const { paxId, declaration } = action.payload as { paxId: number; declaration: boolean };
      return {
        ...state,
        declaration: {
          ...state.declaration,
          [paxId]: declaration
        }
      };
    }
    default:
      return state;
  }
};

export const medQuestionnaire = (state: MQState = { inProgressMQ: {} }, action: MQActions): MQState => {
  switch (action.type) {
    case MQ_SUBMIT: {
      const { paxId, paxMq } = action.payload as MQSubmit;
      const currPaxMq = get(state, paxId, []);
      const filteredMq = filter(currPaxMq, pageData => pageData.page !== paxMq.page);
      return { ...state, [paxId]: [...filteredMq, paxMq] };
    }
    case MQ_IN_PROGRESS: {
      const act = action.payload as MQInProgress;
      return {
        ...state,
        inProgressMQ: act
      };
    }
    case MQ_CATEGORY: {
      const act = action.payload as MQCategory;
      return {
        ...state,
        rateCategory: {
          ...state.rateCategory,
          [act.paxId]: act
        }
      };
    }
    case MQ_RESET_CATEGORY: {
      const { paxId } = action.payload;
      return omit(state, [`rateCategory.${paxId}`]) as MQState;
    }
    case RESET_PAX_MQ:
    case RESET_PAX: {
      const { paxId } = action.payload;
      const paxIds = Array.isArray(paxId) ? paxId : [paxId];
      const combinedPax = flatMap(paxIds, item => [
        item,
        `rateCategory.${item}`,
        `mqPaxIdEligible.${item}`,
        `declaration.${item}`
      ]);
      return omit(state, combinedPax) as MQState;
    }
    case MQ_STARTED:
      // @ts-ignore
      return { ...state, mqStarted: action.payload as boolean };
    case MQ_COMPLETED:
      // @ts-ignore
      return { ...state, mqCompleted: action.payload as boolean };
    case RESET_STORE: {
      const { whitelist } = action.payload as WhitelistAction;
      return checkWhitelist(whitelist, STORE.MQ, state, initialState) as MQState;
    }
    case RESET_MQ: {
      return initialState;
    }
    case MQ_MESSAGE_SHOW:
      return {
        ...state,
        inProgressMQ: {
          ...state.inProgressMQ,
          // @ts-ignore
          mqMessageShow: action.payload as boolean
        }
      };

    default:
      return validateEligibility(state, action as MQInProgressAction | MQCategoryAction);
  }
};
